import { TableRes } from '../global'
import request from '../tools/request'
import { HTTP } from './http'

const { GET, POST } = request

// 品牌信息VO
export interface BrandInfoVO {
  brandCode: string // 品牌编码
  brandName: string // 品牌名称
  controlledSupplier: string // 管控的供应商
  isSupply: string // 是否供货
  state: string // 状态
  categoryCode: string // 类目编码
  categoryName: string // 类目名称
}

// 获取品牌池参数
export interface GetBrandPoolParam {
  brandCode?: string // 品牌编码
  brandName?: string // 品牌名称
  pageNo: number // 页数
  pageSize: number // 条数
  platformCode?: string // 平台编码
  categoryCode?: string // 类目编码
}

// 分页获取品牌池
export const GET_PAGE_BRAND_POOL = (params: GetBrandPoolParam) =>
  POST<TableRes<BrandInfoVO>>(`${HTTP}/dock/getPageBrandPool`, params, 'application/json')import { TableRes } from '../global'
import request from '../tools/request'
import { HTTP } from './http'

const { GET, POST } = request

// 品牌信息VO
export interface BrandInfoVO {
  brandCode: string // 品牌编码
  brandName: string // 品牌名称
  controlledSupplier: string // 管控的供应商
  isSupply: string // 是否供货
  state: string // 状态
  categoryCode: string // 类目编码
  categoryName: string // 类目名称
}

// 获取品牌池参数
export interface GetBrandPoolParam {
  brandCode?: string // 品牌编码
  brandName?: string // 品牌名称
  pageNo: number // 页数
  pageSize: number // 条数
  platformCode?: string // 平台编码
  categoryCode?: string // 类目编码
}

// 分页获取品牌池
export const GET_PAGE_BRAND_POOL = (params: GetBrandPoolParam) =>
  POST<TableRes<BrandInfoVO>>(`${HTTP}/dock/getPageBrandPool`, params, 'application/json')